import { useStore } from "@store/index";
import { useSession } from "next-auth/react";
import { useEffect, useState } from "react";

// A wrapper around next-auth useSession
export function useAuth() {
    const { data: session } = useSession();
    const isLoggedIn = useStore((state) => state.data.me.isLoggedIn);
    const customer = useStore((state) => state.data.me.customer);

    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isAnonymous, setIsAnonymous] = useState(false);
    const [hasSession, setHasSession] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setIsLoading(true);
        const nextIsAuthenticated =
            typeof session !== "undefined" && session !== null && !session?.anonymousId;
        const nextIsAnonymous =
            typeof session?.anonymousId !== "undefined" && session?.anonymousId !== null;
        setIsAuthenticated(isLoggedIn ?? nextIsAuthenticated);
        setIsAnonymous(nextIsAnonymous);
        setHasSession(nextIsAuthenticated || nextIsAnonymous);
        setIsLoading(false);
        if (nextIsAuthenticated) {
            session.user = {
                name: `${customer?.firstName} ${customer?.lastName}`,
            };
        }
    }, [session, customer?.firstName, customer?.lastName]);

    return {
        session,
        isAuthenticated,
        isAnonymous,
        hasSession,
        isLoading,
    };
}
